import { axiosInstance } from "../axios";
import { notifications_apis } from "../ApiConst";

export const getNotifications = async (params) => {
  const { unread, storeNotification, userNotification } = params;

  // const userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

  // const config = {
  //   method: "get",
  //   maxBodyLength: Infinity,
  //   url: `${base_url}api/v0/auth/user/notification/list/`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: "Token " + userToken,
  //   },
  //   params: {
  //     unread,
  //     store_notification: storeNotification,
  //     user_notification: userNotification,
  //   },
  // };

  try {
    const response = await axiosInstance.get(
      notifications_apis.get_notifications,
      {
        params: {
          unread,
          store_notification: storeNotification,
          user_notification: userNotification,
        },
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllNotifications = async (params) => {
  const { storeNotification,  timeFrame } = params;
  // const { unread, storeNotification, userNotification, page, timeFrame } = params;

  // const userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

  // const config = {
  //   method: "get",
  //   maxBodyLength: Infinity,
  //   url: `${base_url}api/v0/auth/user/notification/list/`,
  //   headers: {
  //     "Content-Type": "application/json",
  //     Authorization: "Token " + userToken,
  //   },
  //   params: {
  //     unread,
  //     store_notification: storeNotification,
  //     user_notification: userNotification,
  //     page, // Add page parameter here
  //   },
  // };

  try {
    // const response = await axios.request(config);
    const response = await axiosInstance.get(
      notifications_apis.get_all_notifications,
      {
        params: {
          // unread,
          store_notification: storeNotification,
          // user_notification: userNotification,
          // page,
          time_frame: timeFrame,
        },
        useUserToken: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching notifications:", error);
    throw error;
  }
};

export const getAllNotificationsByUrl = async (url) => {
  const response = await axiosInstance.get(url, {
    useUserToken: true,
  });
  return response.data;
};

export const clickBellIcon = async () => {
  const response = await axiosInstance.put(notifications_apis.click_bell_icon, {},
    { useUserToken: true })
  return response.data;
}


export const markNotificationAsRead = async (notificationId) => {
  // const userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);

  // const config = {
  //   method: 'put',
  //   maxBodyLength: Infinity,
  //   url: `${base_url}api/v0/auth/user/notification/details/${notificationId}/`,
  //   headers: {
  //     'Authorization': 'Token ' + userToken,
  //   },
  // };

  try {
    // const response = await axios.request(config);
    const response = await axiosInstance.put(
      notifications_apis.mark_notification_as_read(notificationId),
      {},
      { useUserToken: true }
    );
    return response.data; // Response after updating the notification
  } catch (error) {
    console.error("Error updating notification status:", error);
    throw error;
  }
};

// export const Submit_Contact_Enquiry = async (name, email, phone, message) => {
//   const data = JSON.stringify({
//     name,
//     email,
//     phone,
//     message,
//   });

//   const config = {
//     method: 'post',
//     maxBodyLength: Infinity,
//     url: `${base_url}api/v0/contact/message/enquiry/`,
//     headers: {
//       Authorization: Token,
//       'Content-Type': 'application/json',
//     },
//     data: data,
//   };

//   try {
//     const response = await axios.request(config);
//     return response.data; // Return the API response
//   } catch (error) {
//     console.error('Contact enquiry submission failed:', error);
//     throw error; // Throw error for the caller to handle
//   }
// };
